export const SET_WITHDRAWAL_LOADING = 'src/Withdrawal/SET_WITHDRAWAL_LOADING';
export const WITHDRAWALS = 'src/Withdrawal/WITHDRAWALS';
export const WITHDRAWAL = 'src/Withdrawal/WITHDRAWAL';

export const SET_EARNINGS = 'src/Withdrawal/SET_EARNINGS';
export const SET_WITHDRAWN_AMOUNT = 'src/Withdrawal/SET_WITHDRAWN_AMOUNT';
export const SET_WITHDRAWAL_COMMISSION = 'src/Withdrawal/SET_WITHDRAWAL_COMMISSION';
export const RESET_WITHDRAWAL = 'src/Withdrawal/RESET_WITHDRAWAL';
export const SET_WITHDRAWAL_PAGINITION = 'src/Withdrawal/SET_WITHDRAWAL_PAGINITION';
export const SET_CAN_WITHDRAWAL_AMOUNT = 'src/Withdrawal/SET_CAN_WITHDRAWAL_AMOUNT';
export const INITIALISE_WITHDRAWAL = 'src/Withdrawal/INITIALISE_WITHDRAWAL';
export const SET_WITHDRAWAL_ORGANIZER = 'src/Withdrawal/SET_WITHDRAWAL_ORGANIZER';
export const CLEAR_WITHDRAWAL_ORGANIZER = 'src/Withdrawal/CLEAR_WITHDRAWAL_ORGANIZER';
export const SET_PROCESSING_WITHDRAWAL = 'src/Withdrawal/SET_PROCESSING_WITHDRAWAL';